import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import axios from "axios";
import { environmentVariables } from "../../config/env.config.js";
import { userContext } from "../../context/userContext.js";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import CircularLoader from "../Components/CircularLoader/CircularLoader.js";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import DataTable from "react-data-table-component";
import SortIcon from "@material-ui/icons/ArrowDownward";
import * as yup from "yup";
import { useFormik } from "formik";
import VerifyOtpBank from './VerifyOtpBank.js'
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// import { Modal } from 'bootstrap';


const BankDetails = ({ tab }) => {
  const { t } = useTranslation();
  const [paymentData, setPaymentData] = useState(null);
  const [amount, setAmount] = useState(null);
  const [planPrice, setPlanPrice] = useState()
  const [isVerifying, setIsVerifying] = useState(true);
  const [DeliveryDate, setDeliveryDate] = useState(null);
  const { userData } = useContext(userContext);
  const [paymentPopUp, setPaymentPopUp] = useState(false);
  const [submitBtn, setSubmitBtn] = useState('');
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [responseData, setResponseData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [isEditMode, setIsEditMode] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [editedData, setEditedData] = useState({});
  const [handleName, setHandleName] = useState("");
  const [bankId, setbankId] = useState("");
  const [edit, setEdit] = useState(false);
  const [initialValues, setInitialValues] = useState({
    account_holder_name: '',
    account_number: '',
    ifsc_code: '',
    bank_name: ''
  })
  const { search } = location;
  const baseUrl = environmentVariables?.apiUrl;
  const modalRef = useRef();

  const abortController = new AbortController();

  const [formData, setFormData] = useState({
    account_holder_name: '',
    account_number: '',
    ifsc_code: '',
    bank_name: '',
    bank_id: ''
  });

  let formik = useFormik({
    initialValues: edit ? formData : initialValues,
    validationSchema: yup.object({
      account_holder_name: yup
        .string()
        .min(2)
        .max(100)
        .required("Account holder name is required"),
      account_number: yup
        .string()
        .required("Account number is required"),
      ifsc_code: yup
        .string()
        .required("IFSC is required"),
      bank_name: yup
        .string()
        .required("Bank name is required")
    }),
    onSubmit: async (values) => {
      setIsSubmit(true);
      // const payload = {
      //   account_holder_name: formik?.values?.account_holder_name,
      //   account_number: formik?.values?.account_number,
      //   ifsc_code: formik?.values?.ifsc_code,
      //   bank_name: formik?.values?.bank_name
      // };

      try {
        const response = await axios.post(`${baseUrl}api/v1/user/${edit ? 'updateBankDetails' : 'createBankDetails'}`, values, {
          headers: {
            'Content-Type': 'application/json',
            _token: userData?.token,
          },
        });
        toast.success(response?.data?.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
        formik.resetForm();
        setIsSubmit(false);
        setbankId(response?.data?.data)
        console.log(bankId)
        fetchBankData(1);
        const closeModalElement = document.querySelector('#closeModal');
        if (closeModalElement) {
          closeModalElement.click();
        }
        if (!edit) {
          const otpModal = document.querySelector('.MyOtpModel');
          if (otpModal) {
            otpModal.click();
          }
        }
        else setEdit(false)
      } catch (error) {
        console.error('Error ', error);
        toast.error(error?.response?.data?.message || error?.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
        setIsSubmit(false);
      }
    },
    enableReinitialize: true,
  });


  const tableExtensions = {
    export: false,
    print: false,
  };
  function useWindowWidth() {
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
      const handleResize = () => setWidth(window.innerWidth);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
    return width;
  }
  const windowWidth = useWindowWidth();

  const handlePageChange = (page) => {
    fetchBankData(page);
  };
  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    fetchBankData(page, newPerPage);
  };

  const getStatusStyle = (status) => {
    const styles = {
      false: { color: "#e71c1f", background: "#e71c1f33" },
      true: { color: "#2892D5", background: "#2892D533" }
    };

    const { color = "#000", background = "#00000033" } = styles[status] || {};

    return {
      fontWeight: "500",
      color,
      background,
      borderRadius: "4px",
      padding: "2px 0px",
      textTransform: "capitalize",
      minWidth: "90px",
      maxWidth: "90px",
      display: "block",
      textAlign: "center",
      cursor: "pointer"
    };
  };

  const handleCloseModal = () => {
    const otpModal = document.querySelector('.MyOtpModel');
    if (otpModal) {
      otpModal.click();
    }


  };

  const handleVerification = async (value) => {
    try {
      setbankId(value?.id)
      let data = {
        bank_id: value?.id
      }
      const response = await axios.post(`${baseUrl}api/v1/user/resendBankOTP`, data, {
        headers: {
          'Content-Type': 'application/json',
          _token: userData?.token,
        },
      });
      toast.success(response?.data?.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
      const otpModal = document.querySelector('.MyOtpModel');
      if (otpModal) {
        otpModal.click();
      }

    } catch (error) {
      console.error('Error ', error);
      toast.error(error?.response?.data?.message || error?.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
    }
  }

  const handleDeleteAccount = async (id) => {
    try {
      const response = await axios.delete(`${baseUrl}api/v1/user/deleteBankDetails/${id}`, {
        headers: {
          'Content-Type': 'application/json',
          _token: userData?.token,
        },
      });
      toast.success(response?.data?.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
      fetchBankData()

    } catch (error) {
      console.error('Error ', error);
      toast.error(error?.response?.data?.message || error?.message, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      });
    }
  }

  const columns = [
    {
      name: t("Account_Holder_Name"),
      selector: (row) => row?.account_holder_name || "--",
      sortable: true,
      cell: (row) => (
        <div className="custom-cell order-id-cell custom-cell-bold" data-column-name={t("Order_id")}>
          {row?.account_holder_name || "--"}
        </div>
      ),
      minWidth: windowWidth > 768 ? "130px" : "100%",
    },
    {
      name: t("Account_Number"),
      selector: (row) => row?.account_number || "--",
      cell: (row) => (
        <div className="custom-cell custom-cell-bold" data-column-name={t("Amount")}>
          {row?.account_number || "--"}
        </div>
      ),
      sortable: true,
      minWidth: "180px",
    },
    {
      name: t("bank_name"),
      selector: (row) => row?.bank_name || "--",
      cell: (row) => (
        <div className="custom-cell custom-cell-bold" data-column-name="Opening Balance">
          {
            row?.bank_name || "--"
          }
        </div>
      ),
      sortable: true,
      minWidth: "180px",
    },
    {
      name: t("Status"),
      selector: (row) => row?.is_verified || "--",
      cell: (row) => (
        <div onClick={() => { row?.is_verified ? "" : handleVerification(row) }} className="custom-cell custom-cell-bold" data-column-name="Opening Balance" style={getStatusStyle(row?.is_verified)} >
          {row?.is_verified ? t("Verified") : t("Unverified")}
        </div>
      ),
      sortable: true,
      minWidth: "180px",
    },
    {
      name: "Action",
      sortable: false,
      cell: (d) => (
        <div style={{ display: "flex", fontSize: "16px" }}>
          <i onClick={() => handleEditOpen(d)} data-bs-toggle="modal" data-bs-target="#planselectedit"
            style={{ cursor: "pointer", marginRight: "10px", width: "100%" }} className="first fas fa-pencil"></i>
          <i onClick={() => handleDeleteAccount(d?.id)} style={{ cursor: "pointer", marginRight: "0px", width: "100%" }} class="fa-solid fa-trash"></i>
        </div>
      ),
      minWidth: "180px"
    }
  ];

  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "#E9E9E9",
        minHeight: "52px",
        borderRadius: "2px 2px 0px 0px",
        padding: "8px 25px",
        border: "none",
        textAlign: "left",
      },
    },
    headCells: {
      style: {
        color: "#525252",
        fontSize: "16px", // Same font size as regular cells
        minHeight: "52px",
        padding: "8px 10px", // Same padding as regular cells
        textAlign: "left",
      },
    },
    rows: {
      style: {
        padding: "6px 0px 6px 25px", // Ensure similar padding here
        fontSize: "13px", // Match font size with header
        textTransform: "capitalize",
        minHeight: "48px !important",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
      },
    },
    cells: {
      style: {
        padding: "0px 5px", // Same padding as header cells
        fontSize: "13px", // Match font size with header
        textAlign: "left", // Ensure same text alignment as header
      },
    },
  };

  const handleEdit = (d) => {
    setOpen(true);
    setSelectedMessage(d);
    setIsModalOpen(true);
  };

  const tableData = {
    columns,
    data: responseData,
  };
  const paginationOptions = {
    rowsPerPageText: t("Rows_per_page"),
    rangeSeparatorText: t("Of"),
    noRowsPerPage: false,
    selectAllRowsItem: false,
  };

  const fetchBankData = async (page, size = perPage) => {
    try {
      console.log("page====>>>>", page);

      const response = await axios.get(
        `${baseUrl}api/v1/user/getBankDetails?page=${page}&limit=${size}`,
        {
          headers: {
            _token: userData?.token,
          }
        }
      );
      console.log("response====>>>", response);

      if (response.status === 200) {
        const { bankDetails, totalRecords } = response?.data;
        setResponseData(bankDetails);
        setTotalRows(totalRecords || 0);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log("error,", error)
      setResponseData([]);
    }
  }
  useEffect(() => {
    fetchBankData(1);
    return () => {
      abortController.abort();
    };

  }, [tab]);

  const handleEditOpen = async (d) => {
    setEdit(true)
    setFormData({
      ...formData,
      account_holder_name: d?.account_holder_name,
      account_number: d?.account_number,
      ifsc_code: d?.ifsc_code,
      bank_name: d?.bank_name,
      bank_id: d?.id
    })

    const myClickModelElement = document.querySelector('.EditClickModel');
    if (myClickModelElement) {
      const formElement = document.getElementById('editForm');
      formElement.reset();
      myClickModelElement.click();
    }

  }
  const handlePlanClick = async () => {
    setEdit(false)
    formik.resetForm();
    setEditedData({});
    setSubmitBtn("Save Changes")
    setHandleName("handleSubmit")

    const myClickModelElement = document.querySelector('.MyClickModel');
    if (myClickModelElement) {
      const formElement = document.getElementById('bplanForm');
      formElement.reset();
      myClickModelElement.click();
    }
  }

  const handleChangeData = (event, key) => {
    let { value } = event.target;
    // Allow only digits and one dot
    if (key === "account_number") {
      value = value.replace(/[^0-9.]/g, '');
    } else if (key === "ifsc_code") {
      value = value.replace(/[^a-zA-Z0-9]/g, '');
    }
    else {
      value = value.replace(/[^a-zA-Z\s]/g, '');
    }

    formik.setFieldValue(key, value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "editPlanName") {
      const validValue = value.replace(/[^a-zA-Z\s]/g, ""); // Allows letters and spaces only
      setFormData((prevData) => ({
        ...prevData,
        [name]: validValue,
      }));
      return;
    }


    const decimalValue = value.replace(/[^0-9.]/g, "");

    // Prevent multiple decimal points
    const parts = decimalValue.split(".");
    let validValue = parts.length > 2
      ? parts[0] + "." + parts[1] // keep only one decimal
      : decimalValue;

    if (validValue.length > 4) {
      validValue = validValue.slice(0, 4);
    }

    const num = parseFloat(validValue);

    if (name === "editPayin" || name === "editPayout") {
      if (!isNaN(num) && num <= 90) {
        validValue = validValue;
      } else {
        validValue = ""; // Clear if invalid
      }
    }

    if (name === "settlement_time") {
      if (!isNaN(num) && num <= 240) {
        validValue = validValue;
      } else {
        validValue = ""; // Clear if invalid
      }
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: validValue,
    }));
  };


  return (
    <>
      <div className="headerData">
        <h3>Banks Details</h3>
        <p className="addrolep">
          <span className="icon-btn addrolemain_role" onClick={handlePlanClick}>
            Add Bank Details <span className="addrole_role">+</span>
          </span>
          <a className="MyClickModel" data-bs-toggle="modal" data-bs-target="#planselectedit"></a>
        </p>
      </div>
      <div className="main">
        {isLoading ? (
          <CircularLoader size={40} />
        ) : (
          <>
            <DataTableExtensions
              {...tableExtensions}
              {...tableData}
              customStyles={customStyles}
              filterPlaceholder="Search User By name"
            >
              <DataTable
                className="customDataTable"
                columns={columns}
                data={responseData}
                noHeader
                defaultSortField="id"
                sortIcon={<SortIcon />}
                defaultSortAsc={true}
                pagination
                paginationServer
                paginationRowsPerPageOptions={[10, 15, 20, 25, 30]}
                paginationTotalRows={totalRows}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handlePerRowsChange}
                highlightOnHover
                dense
                // paginationPerPage={perPage}
                paginationComponentOptions={{
                  ...paginationOptions,
                }}
                progressPending={isLoading}
                customStyles={customStyles}
                noDataComponent={
                  <div style={{ padding: "24px" }}>{t("No_records_found")}</div>
                }
              />
            </DataTableExtensions>
          </>
        )}
      </div>

      <div
        className="modal fade"
        id="planselectedit"
        backdrop="static"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg dialog_wrapper_plan_superadmin">
          <div className="modal-content ">
            <div className="modal-header" style={{ display: "flex", flexDirection: "column" }}>
              <h5 className="modal-title L508" id="exampleModalLabel">
                {edit ? 'Update Bank Details' : "Add Bank Details"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closeModal"
              ></button>
            </div>
            <div className="modal-body ddd">
              <form id="bplanForm">

                <div className="row g-3 mb-3">
                  <div className="col" style={{ position: "relative" }}>
                    <h5 className="lable-custompayment-form">Enter Account Holder Name*</h5>
                    <input
                      type="text"
                      className="form-control"
                      style={{ fontSize: "16px", padding: "12px 25px", border: "1px solid #e5e5e5", background: "#f5f5f5" }}
                      placeholder="Please Enter account holder name"
                      aria-label="account_holder_name"
                      name="account_holder_name"
                      value={formik?.values?.account_holder_name}
                      onChange={(e) => handleChangeData(e, "account_holder_name")}
                      onBlur={formik.handleBlur}
                      disabled={isEditMode}
                    />

                    {formik.touched.account_holder_name && formik.errors.account_holder_name ? (
                      <div style={{ color: "red" }}>
                        {formik.errors.account_holder_name}
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>

                <div className="row g-3 mb-3">
                  <div className="col">
                    <h5 className="lable-custompayment-form">Enter Account Number*</h5>
                    <input
                      type="text"
                      className="form-control"
                      style={{ fontSize: "16px", padding: "12px 25px", border: "1px solid #e5e5e5", background: "#f5f5f5" }}
                      placeholder="Enter Account Number*"
                      name="account_number"
                      value={formik?.values?.account_number}
                      onChange={(e) => handleChangeData(e, "account_number")}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.account_number && formik.errors.account_number ? (
                      <div style={{ color: "red" }}>
                        {formik.errors.account_number}
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>

                </div>
                <div className="row g-3  mb-3">
                  <div className="col">
                    <h5 className="lable-custompayment-form">Enter IFSC*</h5>
                    <input
                      type="text"
                      className="form-control"
                      style={{ fontSize: "16px", padding: "12px 25px", border: "1px solid #e5e5e5", background: "#f5f5f5" }}
                      placeholder="Enter IFSC*"
                      name="ifsc_code"
                      value={formik?.values?.ifsc_code}
                      onChange={(e) => handleChangeData(e, "ifsc_code")}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.ifsc_code && formik.errors.ifsc_code ? (
                      <div style={{ color: "red" }}>
                        {formik.errors.ifsc_code}
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                <div className="row g-3  mb-3">
                  <div className="col">
                    <h5 className="lable-custompayment-form">Enter Bank Name*</h5>
                    <input
                      type="text"
                      className="form-control"
                      style={{ fontSize: "16px", padding: "12px 25px", border: "1px solid #e5e5e5", background: "#f5f5f5" }}
                      placeholder="Enter Bank Name*"
                      name="bank_name"
                      value={formik?.values?.bank_name}
                      onChange={(e) => handleChangeData(e, "bank_name")}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.bank_name && formik.errors.bank_name ? (
                      <div style={{ color: "red" }}>
                        {formik.errors.bank_name}
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>

                <div class="adminplan_buttonwrapper">
                  <button
                    type="button"
                    className="btn btn-primary icon-btn adminplan_deletbutton"
                    aria-label="Close"
                    style={{ margin: "0 10px", background: "#333333", width:"300px" }}
                    onClick={formik.handleSubmit}
                  >
                    {isSubmit ? <CircularLoader size={20} /> : edit ? 'Update Bank Details' : "Add Bank Details"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>


      <a className="MyOtpModel" data-bs-toggle="modal" data-bs-target="#bankOTP"></a>
      <div className="modal fade" ref={modalRef} data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"

        id="bankOTP"
        backdrop="static"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true" >
        <div className="modal-dialog modal-lg dialog_wrapper_plan_superadmin">
          <VerifyOtpBank bankId={bankId} closeModal={handleCloseModal} userData={userData} fetchBankData={fetchBankData} />

        </div>

      </div>


    </>
  );
};
export default BankDetails;
